<template>
  <b-modal
    id="create-org"
    ref="modal"
    centered
    hide-footer
    hide-header
    @show="reset"
  >
    <h2 class="mb-4">Create Organization</h2>

    <form @submit.prevent="onSubmit">
      <NanInput
        v-model="org.name"
        :validation="$v.org.name"
        label="Organization Name"
        placeholder="Nanome"
        class="mb-3"
        autofocus
      />

      <NanInput
        v-model="org.owner_email"
        :validation="$v.org.owner_email"
        label="Owner Email"
        placeholder="user@nanome.ai"
        type="email"
        class="mb-3"
      />

      <NanInput
        v-model="org.hubspot_id"
        label="Hubspot ID"
        placeholder="000000000"
        class="mb-3"
      />

      <div class="text-right">
        <b-btn
          class="ml-2 px-4"
          variant="secondary"
          @click="$bvModal.hide('create-org')"
        >
          Cancel
        </b-btn>
        <b-btn
          :class="{ disabled: $v.$invalid }"
          :disabled="loading"
          class="ml-2 px-4"
          variant="primary"
          type="submit"
        >
          Submit
        </b-btn>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import API from "@/api";

export default {
  mixins: [validationMixin],

  data: () => ({
    loading: false,
    org: {
      name: "",
      owner_email: "",
      hubspot_id: ""
    }
  }),

  methods: {
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid || this.loading) return;

      const data = { ...this.org };
      if (!data.hubspot_id) {
        delete data.hubspot_id;
      }

      this.loading = true;
      const { success } = await API.adminCreateOrg(data);
      this.loading = false;

      if (success) {
        this.$notify({
          type: "success",
          text: "Organization created"
        });
        this.$refs.modal.hide();
        this.$emit("created");
      }
    },

    reset() {
      this.org.name = "";
      this.org.owner_email = "";
      this.org.hubspot_id = "";
      this.$v.$reset();
    }
  },

  validations: {
    org: {
      name: { required },
      owner_email: { required, email }
    }
  }
};
</script>
